<script setup>
import { load } from "cheerio";

const { current_hostname } = useRuntimeConfig().public;
const router = useRoute();
const parseHTMLString = (htmlString) => {
	const $ = load(htmlString);
	return $("body").text() || "";
};

const fetchAuthorByName = async (hostname, authorName) => {
	try {
		const randomParam = Math.random().toString(36).substring(7);

		const response = await fetch(
			`${hostname}wp-json/biographies/v1/author-metadata/all?random=${randomParam}`,
			{
				method: "GET"
			}
		);

		if (response.status === 200) {
			const customAuthors = await response.json();
			const author_name = authorName.replace("-", " ");

			const author = customAuthors.find(
				(author) => author.name.toLowerCase() === author_name
			);

			return author;
		} else {
			console.error("Custom authors request failed:", response.statusText);
			return null;
		}
	} catch (error) {
		console.error("Error loading custom authors:", error);
		return null;
	}
};
const { data, pending } = await useAsyncData(
	`author-biography`,
	async ({ $config, $router }) => {
		try {
			let author = await fetchAuthorByName(
				$config.public.hostname,
				$router.currentRoute._rawValue.params.authorname[0]
			);

			// const schema = {
			// 	"@context": "https://schema.org",
			// 	"@type": "Person",
			// 	name: parseHTMLString(author.name),
			// 	alternateName: "Tim Sykes",
			// 	gender: "Male",
			// 	description: parseHTMLString(author.highlights),
			// 	jobTitle: parseHTMLString(author.position),
			// 	worksFor: {
			// 		"@type": "Organization",
			// 		name: "Timothy Sykes",
			// 		sameAs: "https://www.timothysykes.com"
			// 	},
			// 	url: "https://www.timothysykes.com/blog/author/tim-sykes/",
			// 	// sameAs:
			// 	// 	custom_sections && custom_sections.length > 0
			// 	// 		? custom_sections.values.map((social) => social.value)
			// 	// 		: [],
			// 	knowsAbout: [
			// 		{ "@type": "Thing", name: "Penny Stocks" },
			// 		{ "@type": "Thing", name: "Day Trading" },
			// 		{ "@type": "Thing", name: "Investment Strategies" }
			// 	],
			// 	alumniOf: {
			// 		"@type": "CollegeOrUniversity",
			// 		name: "Tulane University",
			// 		sameAs: "https://www.tulane.edu"
			// 	},
			// 	hasCredential: [
			// 		{
			// 			"@type": "EducationalOccupationalCredential",
			// 			credentialCategory: "Bachelor's Degree",
			// 			educationalLevel: parseHTMLString(author.education),
			// 			recognizedBy: {
			// 				"@type": "CollegeOrUniversity",
			// 				name: "Tulane University",
			// 				sameAs: "https://www.tulane.edu"
			// 			}
			// 		}
			// 	],
			// 	address: {
			// 		"@type": "PostalAddress",
			// 		addressLocality: "Miami",
			// 		addressRegion: "FL",
			// 		addressCountry: "US"
			// 	},
			// 	email: author.contact_email,
			// 	image: author.profile_image,
			// 	mainEntityOfPage: {
			// 		"@type": "WebPage",
			// 		"@id": "https://www.timothysykes.com/blog/author/tim-sykes/"
			// 	},
			// 	birthDate: "1981-04-15",
			// 	nationality: "American",
			// 	hasOccupation: {
			// 		"@type": "Occupation",
			// 		name: "Penny Stock Trader", // Boilerplate text
			// 		occupationalCategory: "Business > Finance > Traders", // Boilerplate text
			// 		estimatedSalary: {
			// 			"@type": "MonetaryAmount",
			// 			currency: "USD",
			// 			value: {
			// 				"@type": "QuantitativeValue",
			// 				value: "100000", // Boilerplate text
			// 				unitText: "YEAR"
			// 			}
			// 		}
			// 	},
			// 	award: [
			// 		"Best Financial Blog 2020 by Finance Bloggers Association",
			// 		"Top Investment Advice Website 2021 by National Finance Awards",
			// 		"Top Trader Award 2022" // Boilerplate text
			// 	],
			// 	sponsor: {
			// 		"@type": "Organization",
			// 		name: "Karmagawa",
			// 		url: "https://www.karmagawa.com"
			// 	},
			// 	// funder:
			// 	// 	funders && funders.length > 0
			// 	// 		? funders.map((item) => ({
			// 	// 				"@type": "Organization",
			// 	// 				name: item.label,
			// 	// 				sameAs: item.value
			// 	// 			}))
			// 	// 		: [],

			// 	honorificPrefix: "Mr.",
			// 	honorificSuffix: "CFA", // Boilerplate text
			// 	memberOf: {
			// 		"@type": "Organization",
			// 		name: "Financial Bloggers Association", // Boilerplate text
			// 		sameAs: "https://www.financialbloggersassociation.com/"
			// 	},
			// 	contactPoint: {
			// 		"@type": "ContactPoint",
			// 		contactType: "customer service",
			// 		email: "support-alerts@timothysykes.com",
			// 		telephone: "+1-888-878-3621"
			// 	},
			// 	publishingPrinciples: "https://www.timothysykes.com/editorial-guidelines/"
			// };

			const schema = {};
			author = {
				...author,
				description: parseHTMLString(author.highlights) ?? ""
			};
			return { author, schema };
		} catch (error) {
			console.log(error);
		}
	}
);

const json_schema = computed(() => {
	if (data.value) {
		return JSON.stringify(data.value.schema);
	}

	return "";
});

useHead({
	script: [
		{
			type: "application/ld+json",
			class: "saswp-schema-markup-output",
			innerHTML: ""
			// innerHTML: json_schema
		}
	],

	title: "StocksToTrade | " + data.value?.author.name,
	meta: [{ name: "description", content: data.value?.author.description || "" }]
});
</script>

<template>
	<Head>
		<Link
			:href="current_hostname.slice(0, -1) + router.fullPath"
			rel="canonical"
		/>
		<Meta
			:content="current_hostname.slice(0, -1) + router.fullPath"
			property="og:url"
		/>
	</Head>
	<AuthorsComponent
		v-if="data && data.author"
		:author-name="data.author.name"
		:author-title="data.author.position"
		:author-expertise="data.author.expertise"
		:author-education="data.author.education"
		:author-highlights="data.author.highlights"
		:experience="data.author.experience"
		:author-education-content="data.author.educationContent"
		:author-email="data.author.contact_email"
		:author-image="data.author.profile_image"
		:custom_sections="data.author.custom_sections"
		:any-object="data.author"
	/>
</template>
